import React from "react";

interface SecurityShieldIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number | string;
}

export default function SecurityShieldIcon({
  size = 24,
  width,
  height,
  ...props
}: SecurityShieldIconProps) {
  return (
    <svg
      width={width ?? size}
      height={height ?? size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.467 20.8199C11.6202 20.9366 11.8075 20.9997 12 20.9997C12.1926 20.9997 12.3798 20.9366 12.533 20.8199C14.168 19.5929 19 15.5859 19 11.0159V6.08595C19.001 5.95878 18.9549 5.83574 18.8705 5.74062C18.7861 5.6455 18.6694 5.58505 18.543 5.57095C16.5407 5.36586 14.6216 4.66245 12.961 3.52495L12.351 3.10795C12.2477 3.037 12.1253 2.99902 12 2.99902C11.8747 2.99902 11.7523 3.037 11.649 3.10795L11.039 3.52495C9.37843 4.66245 7.45936 5.36586 5.45702 5.57095C5.33063 5.58505 5.21395 5.6455 5.12954 5.74062C5.04513 5.83574 4.99899 5.95878 5.00002 6.08595V11.0159C5.00002 15.5859 9.83202 19.5929 11.467 20.8179"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
